import moment from 'moment';

var mixins = {
  filters: {
    formatDate(val, type) {
      if (val === null || val === '' || val === undefined) return '';
      return moment(val).format(type);
    }
  },
  methods: {
    rand(number) {
      return parseInt(parseInt(number) * Math.random());
    },
    moment(val) {
      if (val === null || val === '' || val === undefined) return false;
      return moment(val)
    },
    formatDate(val, type) {
      if (val === null || val === '' || val === undefined) return '';
      return moment(val).format(type);
    }
  }
}
export default mixins



// WEBPACK FOOTER //
// ./src/mixins/dateFormat.js